﻿import { ITicketGroupUser } from './ticket-group-user';

export interface ITicketGroup {
    id: number,
    name: string,
    isNkr: boolean,
    category: number,
    categoryDescription: string,
    userGroupId: number,
    userGroupName: string,
    users: ITicketGroupUser[]
}
